export const privacyPageUrl = 'https://go.microsoft.com/fwlink/?LinkId=521839';
export const MAX_SUBJ_LENGTH = 128;
export const YES = 'Yes';
export const NO = 'No';
